import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./state";

//// Fontawesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faInfoCircle,
  faChevronLeft,
  faChevronDown,
  faUnlink,
  faEnvelopeOpenText,
  faSortAmountUp,
  faSortAmountDownAlt,
  faSortUp,
  faSortDown,
  faTrash,
  faTimes,
  faBars,
  faList,
  faUser,
  faQuestionCircle,
  faPencilAlt,
  faSyncAlt,
  faSearch,
  faTh,
  faEyeSlash,
  faCreditCard,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faChevronRight,
  faInfoCircle,
  faChevronLeft,
  faChevronDown,
  faUnlink,
  faEnvelopeOpenText,
  faSortAmountUp,
  faSortAmountDownAlt,
  faSortUp,
  faSortDown,
  faTrash,
  faTimes,
  faBars,
  faList,
  faUser,
  faQuestionCircle,
  faPencilAlt,
  faSyncAlt,
  faSearch,
  faTh,
  faEyeSlash,
  faCreditCard,
  faUniversity
);

//// Vue select
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

//// Bootstrap
import BootstrapVue from "bootstrap-vue";
// CSS (need both bootstrap and bootstrap-vue styles)
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
// JS (bootstrap-vue UMD bundle below includes includes popper.js, PortalVue, vue-functional-data-merge)
// (bootstrap-vue.js does not depend on bootstrap.js or jquery)
import "bootstrap-vue/dist/bootstrap-vue.min.js";
Vue.use(BootstrapVue);

// Highcharts
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
// Enable chart CSV downloads
import Exporting from "highcharts/modules/exporting";
import HighchartsCSV from "highcharts/modules/export-data";
Exporting(Highcharts);
HighchartsCSV(Highcharts);

// Enable heatmaps
import HighchartsHeatmap from "highcharts/modules/heatmap";
HighchartsHeatmap(Highcharts);

// Configure global options for highcharts
Highcharts.setOptions({
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      animation: false,
    },
  },
});
Vue.use(HighchartsVue);

// Debounce for searching
import vueDebounce from "vue-debounce";
Vue.use(vueDebounce, {
  lock: true,
});

// Disable production tip warning that appears in the console in the browser
Vue.config.productionTip = false;

// Initialize app state from local storage
// This must happen before router instantiation so that
// redirect decisions aren't made with blank app state
store.commit("initializeStore");

// Chargebee
if (window.Chargebee) {
  if (process.env.NODE_ENV === "development") {
    window.Chargebee.init({
      site: "navier-test",
      publishableKey: "test_LI66VWsMnL3cy7KRbnUY8ZILBSJ4LvJq",
    });
  } else {
    window.Chargebee.init({
      site: "navier",
      publishableKey: "live_yogzc1cdLWx7OJCAUvoZxUcdnwjum4d1Xe",
    });
  }
}

// Root vue instance
const root = new Vue({
  router,
  store,
  render: (h) => h(App),
});

// Mount the root view instance
root.$mount("#app");
